<template>
  <transition name="el-zoom-in-center">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Default box -->
        <div class="box">
          <div class="box-header">
            <div class="box-header with-border">
              <h3 class="box-title">修改密码</h3>
            </div>
          </div>
          <div class="box-body">
            <div style="width: auto; text-align: center">
              <!-- 详细样式参考 http://element-cn.eleme.io/#/zh-CN/component/form -->
              <el-form ref="form" label-width="80px" class="form-default">
                <el-form-item label="旧密码">
                  <input type="password" id="oldPassword" class="form-control" v-model="oldP">
                </el-form-item>
                <el-form-item label=" 新密码">
                  <input type="password" id="newPassword" class="form-control" v-model="newP"
                         @input="checkIntensity(newP)">
                  <div id="pwd_Weak" class="pwd pwd_c">&nbsp;</div>
                  <div id="pwd_Medium" class="pwd pwd_c pwd_f">无</div>
                  <div id="pwd_Strong" class="pwd pwd_c pwd_c_r">&nbsp;</div>
                </el-form-item>
                <el-form-item label="确认密码">
                  <input type="password" id="verifyPassword" class="form-control" v-model="verify"
                         @input="checkNew(newP)">
                  <div class="pwd_verify" v-show="show">密码不一致</div>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">提交</el-button>
                  <el-button @click="onCancel">返回</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
  export default {
    name: "password",
    data: function () {
      return {
        oldP: null,
        newP: null,
        verify: null,
        show: false
      }
    },
    mounted: function () {
    },
    methods: {
      checkNew: function () {
        if (this.newP !== this.verify) {
          this.show = true;
        } else {
          this.show = false;
        }
      },
      onSubmit: function () {
        if (this.newP !== this.verify) {
          this.$alert('确认密码需与新密码一致', '警告', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          return;
        }
        let reg = new RegExp(/^[0-9a-zA-Z]*$/g);
        if (reg.test(this.newP) && this.newP.length >= 6 && this.newP.length <= 20) {
        } else {
          this.$alert('密码为6-20位英文或数字', '警告', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          return;
        }
        this.axios.post('/admin/auth/modifyPassword', [],
          {
            params:
              {
                oldPD: this.oldP,
                newPD: this.newP
              }
          })
          .then(resp => { // 保存成功跳回列表页面
            if (resp.data && resp.data.code === 200) {
              this.$message({
                type: 'success',
                message: '修改成功,3秒后返回登录界面!'
              })
              setTimeout(() => {
                localStorage.clear();
                this.$router.replace('/')
              }, 3000);
            } else {
              this.$message({
                type: 'error',
                message: resp.data.message
              })
            }
          }).catch(resp => {
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        })
      },
      onCancel: function () {
        this.$router.replace('/home')
      },
      checkIntensity: function (pwd) {
        var Mcolor, Wcolor, Scolor, text
        var m = 0
        var Modes = 0
        for (var i = 0; i < pwd.length; i++) {
          var charType = 0
          var t = pwd.charCodeAt(i);
          if (t >= 48 && t <= 57) {
            charType = 1
          } else if (t >= 65 && t <= 90) {
            charType = 2
          } else if (t >= 97 && t <= 122) {
            charType = 4
          } else {
            charType = 4
          }
          Modes |= charType
        }
        for (i = 0; i < 4; i++) {
          if (Modes & 1) {
            m++
          }
          Modes >>>= 1
        }
        if (pwd.length <= 4) {
          m = 1
        }
        if (pwd.length <= 0) {
          m = 0
        }
        switch (m) {
          case 1 :
            Wcolor = "pwd pwd_Weak_c"
            Mcolor = "pwd pwd_c"
            Scolor = "pwd pwd_c pwd_c_r"
            text = "弱"
            break
          case 2 :
            Wcolor = "pwd pwd_Medium_c"
            Mcolor = "pwd pwd_Medium_c"
            Scolor = "pwd pwd_c pwd_c_r"
            text = "中"
            break
          case 3 :
            Wcolor = "pwd pwd_Strong_c"
            Mcolor = "pwd pwd_Strong_c"
            Scolor = "pwd pwd_Strong_c pwd_Strong_c_r"
            text = "强"
            break;
          default :
            Wcolor = "pwd pwd_c"
            Mcolor = "pwd pwd_c pwd_f"
            Scolor = "pwd pwd_c pwd_c_r"
            text = "无"
            break;
        }
        document.getElementById('pwd_Weak').className = Wcolor;
        document.getElementById('pwd_Medium').className = Mcolor;
        document.getElementById('pwd_Strong').className = Scolor;
        document.getElementById('pwd_Medium').innerHTML = text;
      }
    }
  }
</script>

<style scoped>
  .pwd_verify {
    width: 130px;
    height: 25px;
    line-height: 20px;
    padding-top: 2px;
    border-radius: 5px;
    float: left;
    margin-top: 5px;
    margin-right: 2px;
    font-size: 14px;
    background-color: #E9AE10;
  }

  .pwd {
    width: 40px;
    height: 25px;
    line-height: 20px;
    padding-top: 2px;
    border-radius: 5px;
    float: left;
    margin-top: 5px;
    margin-right: 2px;
    font-size: 14px;
  }

  .pwd_f {
    color: #BBBBBB;
  }

  .pwd_c {
    background-color: #F3F3F3;
    border: 1px solid #D0D0D0;

  }

  .pwd_Weak_c {
    background-color: #FF4545;
    border: 1px solid #BB2B2B;
  }

  .pwd_Medium_c {
    background-color: #FFD35E;
    border: 1px solid #E9AE10;
  }

  .pwd_Strong_c {
    background-color: #3ABB1C;
    border: 1px solid #267A12;
  }

  .pwd_c_r {
    border-right: 1px solid #D0D0D0;
  }

  .pwd_Weak_c_r {
    border-right: 1px solid #BB2B2B;
  }

  .pwd_Medium_c_r {
    border-right: 1px solid #E9AE10;
  }

  .pwd_Strong_c_r {
    border-right: 1px solid #267A12;
  }
</style>



// WEBPACK FOOTER //
// Password.vue?28865a16